



















































import Vue from 'vue';
import { mapActions } from 'vuex';

import api from '../../api';
import MovieFeature from '../../components/ui/features/movie-feature.vue';
import ShowCards from '../../components/ui/show-cards/show-cards.vue';

import { IShow } from '../../../../shared/types';

export default Vue.extend({
  name: 'Landing',

  components: {
    ShowCards,
    MovieFeature,
  },

  data: () => ({
    popularShows: [] as IShow[],
    popularMovies: [] as IShow[],
    topMovies: [] as IShow[],
    topShows: [] as IShow[],
  }),

  async created() {
    this.handlePageLoad({
      name: this.$route.name,
    });

    this.popularShows = await api.show.getPopularTvShows();
    this.popularMovies = await api.show.getPopularMovies();
    this.topMovies = await api.show.getTopRatedMovies();
    this.topShows = await api.show.getTopRatedTvShows();
  },

  computed: {
    featureMovie() {
      if (this.popularMovies.length > 0) {
        return this.popularMovies[0];
      }
      return null;
    },
  },

  methods: {
    loginPage() {
      this.$router.push('/login');
    },

    ...mapActions('navigation', [
      'handlePageLoad',
    ]),
  },
});
